export enum RequestLockStatus {
  NoStatus = 0,
  NotLocked = 1,
  ActiveLock = 2,
  Expired = 3,
  Cancelled = 4,
}

export enum RequestActionType {
  QuoteRequest = 1,
  ValidateReLock = 2,
  CheckEligibilityAndPricing = 3,
  BuyRequest = 4,
  SellRequest = 5,
  WorstCaseHistorical = 6,
  WorstCaseCurrent = 7,
  ValidateLock = 8,
  LockUpdate = 9,
  ExtendLock = 10,
}

export enum RateRequestStatus {
  NotLockedNoRequest = 'NotLocked-NoRequest',
  NotLockedRequest = 'NotLocked-Request',
  LockedNoRequest = 'Locked-NoRequest',
  LockedRequest = 'Locked-Request',
  LockedExtensionRequest = 'Locked-Extension-Request',
  LockedCancellationRequest = 'Locked-Cancellation-Request',
  Cancelled = 'Cancelled',
  ExpiredNoRequest = 'Expired-NoRequest',
  ExpiredRequest = 'Expired-Request',
  ExpiredExtensionRequest = 'Expired-Extension-Request',
}
